/* Storefront decision events. Purchase completion belongs to checkout integrations.
   No names, dedication text, email, phone or cart properties enter analytics. */
(function () {
  'use strict';
  var sent = new Set();
  function track(name, data, once) {
    var key = name + ':' + (data.product_id || '') + ':' + (data.step || '');
    if (once && sent.has(key)) return;
    var shopify = window.Shopify;
    if (!shopify || !shopify.customerPrivacy || !shopify.customerPrivacy.analyticsProcessingAllowed()) return;
    if (window.HovAnalytics) window.HovAnalytics.capture(name, data);
    if (once) sent.add(key);
    if (!shopify.analytics || !shopify.analytics.publish) return;
    try {
      var result = shopify.analytics.publish(name, data);
      if (result && result.catch) result.catch(function () {});
      if (once) sent.add(key);
    } catch (e) {}
  }
  document.addEventListener('input', function (e) {
    var root = e.target.closest('[data-hov-ded]');
    if (root && e.target.matches('[data-hov-field]') && e.target.value.trim()) {
      track('hov_dedication_started', { product_id: root.dataset.product }, true);
    }
  });
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (link && /\/pages\/(contact|bulk-gifting)|wa\.me\/|^mailto:/.test(link.href)) {
      var bulk = link.href.includes('bulk-gifting') || location.pathname.includes('bulk-gifting');
      var channel = link.href.includes('wa.me/') ? 'whatsapp' : link.href.startsWith('mailto:') ? 'email' : 'page';
      track('hov_help_requested', { step: bulk ? 'bulk' : 'support', channel: channel });
    }
    var inspiration = e.target.closest('[data-hov-message]');
    if (inspiration) track('hov_dedication_inspiration', { product_id: inspiration.closest('[data-hov-ded]').dataset.product });
    var jump = e.target.closest('.hov-product-jumps a');
    if (jump) track('hov_product_detail_opened', { step: jump.hash.startsWith('#HovDed') ? 'dedication' : jump.hash.startsWith('#HovAnswers') ? 'delivery' : 'preview' });
  });
  document.addEventListener('toggle', function (e) {
    if (e.target.open && e.target.matches('.hov-faq details, .hov-buy-answers')) track('hov_question_opened', { step: e.target.classList.contains('hov-buy-answers') ? 'before_order' : 'faq' });
  }, true);
})();


/* PostHog US: Shopify consent is the source of truth. Never pass form/cart contents. */
(function () {
  'use strict';
  if (window.HovAnalytics || /\/(checkout|checkouts|orders|challenge)(\/|$)/.test(location.pathname)) return;
  var client;
  var loading = false;
  var ready = false;
  var pageViewed = false;
  var pending = [];
  var pendingCustomer = null;
  var identityConfig = document.querySelector('#HovAnalyticsConfig');
  var loggedInCustomer = identityConfig && identityConfig.dataset.customerId;
  var identitySynced = false;
  var environment = window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main' ? 'production' : 'preview';
  function allowed() {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed()); }
    catch (e) { return false; }
  }
  // A string cut inside an emoji leaves half of it, and PostHog answers 400 to the whole batch.
  function whole(text) {
    if (typeof text.toWellFormed === 'function') return text.toWellFormed();
    return text.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDFFF]/g, function (m) { return m.length === 2 ? m : '\uFFFD'; });
  }
  // PostHog takes these from the event's own properties, after its own; an empty distinct_id gets
  // the whole batch refused. Fields of these names from GoKwik are kept as gk_<name>.
  var OWN = { distinct_id: 1, token: 1, uuid: 1, event: 1, timestamp: 1 };
  // The funnel, sent the moment it happens (PostHog's send_instantly: its own transport and retries,
  // beacons once the page is going away). Batched, a step waits up to three seconds in the page, and
  // an in-app browser sent to the background in that time loses it (16 Oct 2026: an Instagram
  // shopper reached payment and none of the steps arrived).
  var INSTANT = /^hov_(add_to_cart_started|added_to_cart|checkout_clicked|checkout_step|checkout_closed|gokwik)$/;
  function capture(name, properties) {
    if (!allowed()) return false;
    var product = document.querySelector('[data-hov-ded][data-product]');
    var handle = /\/products\/([^/]+)/.exec(location.pathname);
    var safe = { environment: environment, $current_url: location.href, $pathname: location.pathname, instrumentation_version: '2026-10-11', page_type: handle ? 'product' : location.pathname === '/' ? 'home' : /\/cart\/?$/.test(location.pathname) ? 'cart' : 'other' };
    if (handle) safe.product_handle = handle[1];
    if (product) {
      safe.page_product_id = String(product.dataset.product);
      if (!/^hov_cart_/.test(name)) safe.product_id = safe.page_product_id;
    }
    ['product_id', 'variant_id', 'step', 'section', 'destination', 'action', 'source', 'review_id', 'reason', 'provider', 'media_type'].forEach(function (key) {
      if (properties && properties[key] != null) safe[key] = whole(String(properties[key]).slice(0, 150));
    });
    ['depth_percent', 'active_seconds', 'interval_seconds', 'visible_seconds', 'quantity', 'item_count', 'review_count', 'media_index', 'milestone_seconds'].forEach(function (key) {
      if (properties && typeof properties[key] === 'number' && Number.isFinite(properties[key]) && properties[key] >= 0) safe[key] = Math.round(properties[key] * 10) / 10;
    });
    if (properties && typeof properties.selected === 'boolean') safe.selected = properties.selected;
    // GoKwik checkout steps: the adapter below has already removed payment details and credentials;
    // keep the rest as it is.
    if (properties && /^hov_(gokwik|checkout_closed)$/.test(name)) Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (Object.prototype.hasOwnProperty.call(safe, key) || key.charAt(0) === '$') return;
      var as = OWN[key] ? 'gk_' + key : key;
      if (typeof value === 'string') safe[as] = whole(value.slice(0, 1000));
      else if (typeof value === 'boolean' || (typeof value === 'number' && Number.isFinite(value))) safe[as] = value;
      else if (value && typeof value === 'object') { try { var json = JSON.stringify(value); if (json.length <= 30000) safe[as] = JSON.parse(json, function (k, v) { return typeof v === 'string' ? whole(v) : v; }); } catch (_) { /* cyclic */ } }
    });
    try {
      var leaving = name === 'hov_page_engagement' && properties && properties.reason === 'pagehide';
      var now = INSTANT.test(name) || (name === 'hov_page_engagement' && properties && properties.reason === 'hidden');
      if (ready) client.capture(name, safe, leaving ? { transport: 'sendBeacon', send_instantly: true } : now ? { send_instantly: true } : undefined);
      else if (pending.length < 100) pending.push([name, safe]);
      else return false;
      return true;
    } catch (_) { return false; } // Analytics must never break a store interaction.
  }
  function customerId(value) {
    if (typeof value === 'number' && !Number.isSafeInteger(value)) return null;
    var match = /^(?:gid:\/\/shopify\/Customer\/)?([1-9][0-9]{0,19})$/.exec(String(value || ''));
    return match ? 'shopify_customer_' + match[1] : null;
  }
  function identifyCustomer(value, source) {
    if (!allowed() || ['shopify_login', 'gokwik_checkout'].indexOf(source) === -1) return false;
    var id = customerId(value);
    if (!id) return false;
    if (!ready) { pendingCustomer = { value: value, source: source }; return true; }
    try {
      var previous = client.get_property('$user_id');
      // Never merge two known people using a shared device.
      if (previous && previous !== id) client.reset();
      if (previous !== id) client.identify(id);
      client.register({ hov_identity_source: source });
      return true;
    } catch (_) { return false; }
  }
  window.HovAnalytics = { capture: capture, allowed: allowed, identifyCustomer: identifyCustomer };
  function activate() {
    if (!client || !allowed()) return;
    client.opt_in_capturing({ captureEventName: false });
    ready = true;
    if (!identitySynced) {
      if (loggedInCustomer) identifyCustomer(loggedInCustomer, 'shopify_login');
      else {
        // A prior authenticated Shopify session has ended. Guest checkout identity
        // remains available across visits until explicit logout or another known user.
        if (client.get_property('hov_identity_source') === 'shopify_login') client.reset();
        if (pendingCustomer) identifyCustomer(pendingCustomer.value, pendingCustomer.source);
      }
      pendingCustomer = null;
      identitySynced = true;
    }
    if (!pageViewed) {
      capture('$pageview');
      var product = document.querySelector('[data-hov-ded][data-product]');
      if (/\/products\//.test(location.pathname)) capture('hov_product_viewed', { product_id: product && product.dataset.product });
      pageViewed = true;
    }
    pending.splice(0).forEach(function (event) { client.capture(event[0], event[1]); });
  }
  function syncConsent() {
    if (!allowed()) {
      ready = false;
      pending = [];
      pendingCustomer = null;
      identitySynced = false;
      if (client) { client.stopSessionRecording(); client.opt_out_capturing(); }
      return;
    }
    if (client) { activate(); return; }
    if (loading) return;
    loading = true;
    // Official async loader. Loaded only after Shopify allows analytics.
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    window.posthog.init('phc_zY7HF56ETAmkNStAipmrUquYMjK4UT3WLt8uWJHkLgzn', {
      api_host: 'https://p.veloccy.com',
      ui_host: 'https://us.posthog.com',
      defaults: '2026-05-30',
      debug: environment === 'preview' && /(?:[?&])hov_analytics_debug=1(?:&|$)/.test(location.search || ''),
      autocapture: true,
      // The page view is sent by activate(), once, after Shopify allows analytics.
      capture_pageview: false,
      capture_pageleave: true,
      capture_dead_clicks: true,
      capture_heatmaps: true,
      capture_exceptions: true,
      capture_performance: true,
      disable_surveys: true,
      person_profiles: 'identified_only',
      opt_out_capturing_by_default: true,
      opt_out_persistence_by_default: true,
      save_referrer: true,
      save_campaign_params: true,
      enable_recording_console_log: false,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '[data-hov-ded], [data-hov-out], .cart-item__details',
        blockSelector: '[data-hov-ded], .hov-dplate, .hov-ded-preview, cart-drawer, #main-cart-items, .customer, shopify-accelerated-checkout, [data-review-form], .gokwik-modal',
        recordHeaders: false,
        recordBody: false,
        recordCrossOriginIframes: false
      },
      before_send: function (event) {
        if (!allowed()) return null;
        event.properties = event.properties || {};
        event.properties.environment = environment;
        event.properties.instrumentation_version = '2026-10-11';
        return event;
      },
      loaded: function (instance) {
        client = instance;
        syncConsent();
      }
    });
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify && Shopify.customerPrivacy) syncConsent();
  else if (window.Shopify && Shopify.loadFeatures) {
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) syncConsent();
    });
  }
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('a, button');
    if (!target) return;
    if (target.matches('a[href]') && /\/account\/logout\/?$/.test(target.pathname) && ready && allowed()) {
      try { client.reset(); } catch (_) {}
    }
    var section = target.closest('[id^="shopify-section-"]');
    var info = { section: section ? section.id : 'global' };
    if (target.matches('.hov-btn, .hov-inline-cta a')) {
      info.destination = target.pathname || '';
      capture('hov_cta_clicked', info);
    }
    // The sticky bar's button is a checkout only when it is set to Buy now; set to Add to cart or
    // Personalise it is counted by the add-to-cart and CTA events instead (until 17 Oct 2026 every
    // sticky Add to cart was also logged here as a checkout tap).
    var sticky = target.matches('[data-hov-buy]');
    if ((sticky ? target.dataset.action === 'buy_now' : target.matches('[name="checkout"], .shopify-payment-button__button')) && !target.matches('.gokwik-marge')) capture('hov_checkout_clicked', info);
  });
})();

/* Bounded, consent-aware behavioural measurements. Visibility is an opportunity to
   read, not proof of reading. Never inspect labels, field contents or cart properties. */
(function () {
  'use strict';
  var analytics = window.HovAnalytics;
  if (!analytics) return;
  var emit = analytics.capture;
  var once = new Set();
  var lastActivity = Date.now(), lastTick = Date.now(), activeSeconds = 0, reportedSeconds = 0;
  var depth = 0, hasScrolled = false;
  var watched = new Map();
  var drawerOpen = false, drawerSeconds = 0, cartSource = 'automatic';
  function section(node) {
    var wrapper = node.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace(/^shopify-section-/, '').split('__').pop() : 'global';
  }
  function info(node) {
    var reviews = node.closest('hov-reviews');
    var card = node.closest('[data-review-id]');
    var data = { section: section(node) };
    if (reviews) data.product_id = reviews.dataset.productId;
    if (card) data.review_id = card.dataset.reviewId;
    return data;
  }
  function emitOnce(key, name, data) {
    if (!once.has(key) && emit(name, data)) once.add(key);
  }
  function active(now) {
    return analytics.allowed() && !document.hidden && document.hasFocus() && now - lastActivity < 60000;
  }
  function tick() {
    var now = Date.now();
    // Do not backfill a throttled/suspended timer, a hidden tab or pre-consent time.
    var elapsed = Math.min(2, Math.max(0, (now - lastTick) / 1000));
    lastTick = now;
    if (!active(now)) return;
    var checkout = document.querySelector('#gokwik-div');
    if (checkout && checkout.getClientRects().length && getComputedStyle(checkout).display !== 'none') return;
    activeSeconds += elapsed;
    if (drawerOpen) drawerSeconds += elapsed;
    [10, 30, 60, 120, 300].forEach(function (seconds) {
      if (activeSeconds >= seconds) emitOnce('engaged:' + seconds, 'hov_page_engaged', { milestone_seconds: seconds, active_seconds: Math.floor(activeSeconds), depth_percent: depth });
    });
    watched.forEach(function (state, node) {
      if (!node.isConnected || node.hidden || !state.visible || (drawerOpen && !node.closest('cart-drawer'))) return;
      state.seconds += elapsed;
      if (state.seconds < 2) return;
      var data = info(node);
      data.visible_seconds = Math.floor(state.seconds);
      if (state.kind === 'review') emitOnce('review:' + data.review_id, 'hov_review_seen', data);
      else {
        emitOnce('section:' + data.section, 'hov_section_viewed', data);
        if (state.kind === 'reviews') {
          emitOnce('reviews:' + data.section, 'hov_reviews_viewed', data);
          [10, 30, 60].forEach(function (seconds) {
            if (state.seconds >= seconds) emitOnce('reviews:' + data.section + ':' + seconds, 'hov_reviews_engaged', Object.assign({}, data, { milestone_seconds: seconds }));
          });
        }
      }
    });
  }
  function report(reason) {
    var seconds = Math.floor(activeSeconds), interval = seconds - reportedSeconds;
    if (interval > 0 && emit('hov_page_engagement', { active_seconds: seconds, interval_seconds: interval, depth_percent: depth, reason: reason })) reportedSeconds = seconds;
  }
  function wake() { lastActivity = Date.now(); }
  ['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (event) {
    window.addEventListener(event, wake, { passive: true, capture: true });
  });
  window.addEventListener('focus', function () { lastTick = Date.now(); wake(); });
  window.addEventListener('blur', function () { report('blur'); lastTick = Date.now(); });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) report('hidden');
    else wake();
    lastTick = Date.now();
  });
  window.addEventListener('pagehide', function () { report('pagehide'); });
  window.addEventListener('pageshow', function () { lastTick = Date.now(); wake(); });
  document.addEventListener('visitorConsentCollected', function () {
    lastTick = Date.now();
    // No delayed exposure/dwell from a period without permission.
    watched.forEach(function (state) { state.seconds = 0; });
    if (analytics.allowed()) { wake(); scan(); }
  });
  setInterval(tick, 1000);
  setInterval(function () { if (active(Date.now())) report('heartbeat'); }, 30000);

  var scrollPending = false;
  window.addEventListener('scroll', function () {
    wake(); hasScrolled = true;
    if (scrollPending) return;
    scrollPending = true;
    requestAnimationFrame(function () {
      scrollPending = false;
      if (!analytics.allowed() || document.hidden || !hasScrolled) return;
      var height = document.documentElement.scrollHeight;
      if (height <= window.innerHeight) return;
      var current = Math.min(100, Math.round(100 * (window.scrollY + window.innerHeight) / height));
      depth = Math.max(depth, current);
      [25, 50, 75, 90, 100].forEach(function (percent) {
        if (depth >= percent) emitOnce('scroll:' + percent, 'hov_scroll_depth', { depth_percent: percent });
      });
    });
  }, { passive: true });

  var observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = watched.get(entry.target);
      if (!state) return;
      // Works for sections taller than a viewport as well as compact review cards.
      var needed = Math.min(entry.boundingClientRect.height * 0.5, window.innerHeight * 0.4);
      state.visible = entry.isIntersecting && entry.intersectionRect.height >= needed;
    });
  }, { threshold: [0, 0.05, 0.1, 0.2, 0.3, 0.5, 0.75, 1] }) : null;
  function watch(node, kind) {
    if (!observer || watched.has(node)) return;
    watched.set(node, { kind: kind, visible: false, seconds: 0 });
    observer.observe(node);
  }
  function scan() {
    document.querySelectorAll('main [id^="shopify-section-"]').forEach(function (node) {
      watch(node, node.querySelector('hov-reviews, .hov-home-reviews') ? 'reviews' : 'section');
    });
    document.querySelectorAll('[data-review-id]').forEach(function (node) { watch(node, 'review'); });
    watched.forEach(function (_, node) { if (!node.isConnected) { observer.unobserve(node); watched.delete(node); } });
  }
  scan();
  document.addEventListener('hov:reviews-loaded', scan);

  var drawer = document.querySelector('cart-drawer');
  function syncDrawer() {
    if (!drawer) return;
    var open = drawer.classList.contains('active');
    // hov.js opens the drawer on the tap, before Shopify has added the copy. Count the cart once
    // the real one has landed (the class change brings us back here), as before the early open.
    if (open && !drawerOpen && (drawer.classList.contains('hov-adding') || drawer.classList.contains('hov-adding--more'))) return;
    if (open === drawerOpen) return;
    drawerOpen = open;
    if (open) {
      drawerSeconds = 0;
      var count = 0;
      drawer.querySelectorAll('input[name="updates[]"]').forEach(function (input) { count += Number(input.value) || 0; });
      // Book lines have no quantity box (one line per copy, 14 Oct 2026): count them from their
      // dedication box, which carries the line's quantity.
      drawer.querySelectorAll('[data-hov-cded][data-qty]').forEach(function (box) {
        var row = box.closest && box.closest('.cart-item');
        if (row && !row.querySelector('input[name="updates[]"]')) count += Number(box.dataset.qty) || 1;
      });
      emit('hov_cart_opened', { source: cartSource, item_count: count });
      cartSource = 'automatic';
    } else emit('hov_cart_closed', { active_seconds: Math.floor(drawerSeconds) });
  }
  if (drawer && typeof MutationObserver === 'function') {
    new MutationObserver(syncDrawer).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    syncDrawer();
  }
  if (/\/cart\/?$/.test(location.pathname)) emitOnce('cart-page', 'hov_cart_viewed', { source: 'cart_page' });

  // GoKwik stops click propagation at window before deferred scripts. Its loader
  // transition records checkout intent without modifying or wrapping vendor code.
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (changes) {
      var handled = new Set();
      changes.forEach(function (change) {
        var node = change.target;
        if (handled.has(node)) return;
        if (!node.matches('.gokwik-marge.processing') || /(?:^|\s)processing(?:\s|$)/.test(change.oldValue || '')) return;
        handled.add(node);
        var kind = node.dataset.gokwikFunction || node.dataset.function;
        emit('hov_checkout_clicked', { provider: 'gokwik', source: kind === 'checkout' ? 'cart' : 'buy_now', section: section(node) });
        // The step adapter times the checkout from this tap (load_ms, closes before it renders).
        if (typeof window.HovCheckoutClicked === 'function') window.HovCheckoutClicked(kind === 'checkout' ? 'cart' : 'buy_now');
      });
    }).observe(document.body, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    var node = event.target.closest && event.target.closest('a, button, summary');
    if (!node || node.disabled || node.getAttribute('aria-disabled') === 'true') return;
    var data = info(node);
    if (node.closest('#cart-icon-bubble')) cartSource = 'header';
    if (node.matches('[data-view-all]')) emit('hov_reviews_expand_clicked', data);
    if (node.matches('[data-collapse]')) emit('hov_reviews_collapsed', data);
    if (node.matches('[data-hov-ex-more]')) emit('hov_excerpt_toggled', Object.assign(data, { selected: node.getAttribute('aria-expanded') !== 'true' }));
    if (node.matches('[data-hov-upsell-go]')) emit('hov_cart_upgrade_clicked', data);
    if (node.matches('[data-hov-copy2-save]')) emit('hov_cart_dedication_save_clicked', data);
    if (node.matches('[data-hov-offer-close]')) emit('hov_offer_dismissed', data);
    if (node.matches('a[href]') && node.origin === location.origin) {
      var path = node.pathname;
      // Route only; no search terms, query strings or fragment values.
      if (/^\/products\/[^/]+\/?$/.test(path)) emit('hov_product_link_clicked', Object.assign(data, { destination: path }));
      else if (node.closest('header, footer, .menu-drawer')) emit('hov_navigation_clicked', Object.assign(data, { destination: path }));
    }
  }, true);
  document.addEventListener('toggle', function (event) {
    var node = event.target;
    if (!node.open) return;
    if (node.matches('.hov-review__more')) emit('hov_review_expanded', info(node));
    if (node.matches('.hov-review__reply')) emit('hov_review_reply_opened', info(node));
    if (node.matches('.hov-reviews__form')) emit('hov_review_form_opened', info(node));
    if (node.matches('.hov-ded-preview')) emit('hov_dedication_preview_opened', info(node));
  }, true);
  document.addEventListener('input', function (event) {
    var form = event.target.closest('[data-review-form]');
    if (form) emitOnce('review-form:' + section(form), 'hov_review_form_started', info(form));
  });
  document.addEventListener('change', function (event) {
    var node = event.target;
    if (node.matches('[data-hov-addon]')) emit('hov_addon_changed', Object.assign(info(node), { variant_id: node.value, selected: node.checked }));
    if (node.matches('[data-hov-gift]')) emit('hov_gift_option_changed', Object.assign(info(node), { selected: node.checked }));
    if (node.matches('variant-selects input, variant-selects select')) emit('hov_variant_option_changed', info(node));
  });
  document.querySelectorAll('[data-fb-count]').forEach(function (node) {
    var previous = node.textContent;
    if (typeof MutationObserver !== 'function') return;
    new MutationObserver(function () {
      if (node.textContent === previous) return;
      previous = node.textContent;
      emit('hov_book_page_turned', Object.assign(info(node), { media_index: Number(node.textContent) }));
    }).observe(node, { childList: true, characterData: true, subtree: true });
  });
  // Scroll-settled positions include touch swipes, keyboard navigation and arrows.
  document.querySelectorAll('[data-hov-slides] [data-track], [data-hov-plates] [data-track], .product__media-list, .hov-slider__track').forEach(function (track) {
    var timer, previous = 0;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var items = Array.from(track.children);
        var left = track.getBoundingClientRect().left;
        var index = items.reduce(function (best, item, i) { return Math.abs(item.getBoundingClientRect().left - left) < Math.abs(items[best].getBoundingClientRect().left - left) ? i : best; }, 0);
        if (!items.length || index === previous) return;
        previous = index;
        emit('hov_gallery_changed', Object.assign(info(track), { media_index: index + 1, source: 'scroll' }));
      }, 200);
    }, { passive: true });
  });
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    var current = gallery.querySelector('.product__media-item.is-active');
    if (typeof MutationObserver !== 'function') return;
    new MutationObserver(function () {
      var next = gallery.querySelector('.product__media-item.is-active');
      if (!next || next === current) return;
      current = next;
      emit('hov_gallery_changed', Object.assign(info(gallery), { media_index: Array.from(gallery.querySelectorAll('.product__media-item')).indexOf(next) + 1, source: 'selection' }));
    }).observe(gallery, { attributes: true, attributeFilter: ['class'], subtree: true });
  });
  var played = new WeakSet(), completed = new WeakSet();
  ['play', 'ended'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (event.target.tagName !== 'VIDEO') return;
      var seen = name === 'play' ? played : completed;
      if (seen.has(event.target) || !analytics.allowed()) return;
      seen.add(event.target);
      emit('hov_video_' + (name === 'play' ? 'played' : 'completed'), Object.assign(info(event.target), { source: event.target.autoplay ? 'autoplay' : 'player', media_type: 'video' }));
    }, true);
  });
})();

/* Adapter for the current GoKwik iframe message contract, inspected in the vendor
   integration. Only known step names and a Shopify customer ID leave this adapter.
   The complete payload (phone/address/email/cart) must never enter PostHog. */
(function () {
  var analytics = window.HovAnalytics;
  if (!analytics) return;
  var steps = { checkoutStarted: 'started', mobileAddedGK: 'contact', addressAdded: 'shipping', paymentStep: 'payment', paymentMethod: 'payment_method', orderPlaced: 'order_placed' };
  var seen = new Set();
  window.addEventListener('message', function (event) {
    if (!analytics.allowed() || event.origin !== 'https://pdp.gokwik.co') return;
    var frame = document.querySelector('#gokwik-iframe');
    if (!frame || event.source !== frame.contentWindow) return;
    var message = event.data;
    if (!message || typeof message !== 'object' || Array.isArray(message)) return;
    var payload = message.data;
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return;
    // This ID is furnished by GoKwik after the customer has reached payment.
    if (['paymentMethod', 'paymentCompleted', 'orderPlaced'].indexOf(message.eventName) !== -1 && payload.shopifyCustomerId) {
      analytics.identifyCustomer(payload.shopifyCustomerId, 'gokwik_checkout');
    }
    if (message.analyticsName === 'shopifyAnalytics' && steps[message.eventName]) {
      var step = steps[message.eventName];
      if (!seen.has(step) && analytics.capture('hov_checkout_step', { provider: 'gokwik', step: step })) seen.add(step);
    }
  });
})();

/* GoKwik's own step log. Besides the shopifyAnalytics messages above, the checkout frame posts
   every internal step to this page as { type: 'gk_sdk_event', data: { name, eventType, data } }.
   The full list comes from parsing GoKwik's checkout.js (15 Oct 2026): 534 logger names, 29 typed
   messages and 16 shopifyAnalytics step names; the map is in gokwik/events/README.md.
   Each step becomes hov_gokwik with the step name, seconds since the checkout opened, GoKwik's own
   fields for it, and the shopper as far as GoKwik has told this page (customer_phone, customer_name,
   customer_email, address, city, state, pincode). Closing the checkout sends hov_checkout_closed with
   where it got to and who it was. The founder's call (15 Oct 2026): everything goes to PostHog except
   payment details. Never sent: card number, CVV, expiry, card holder, UPI ids and pay links, and
   login tokens and OTPs (credentials: a token in PostHog would let anyone with access sign in as the
   shopper). */
(function () {
  var analytics = window.HovAnalytics;
  var DENY = /card|cvv|expiry|valid_?through|^bin$|vpa|upi_?id|token$|jwt|password|secret|cookie|^otp$|^link$/i;
  function scrub(value, depth) {
    if (value == null || typeof value === 'boolean') return value;
    if (typeof value === 'number') return isFinite(value) ? value : undefined;
    if (typeof value === 'string') return value.slice(0, 1000);
    if (typeof value !== 'object' || depth > 5) return undefined;
    if (Array.isArray(value)) return value.slice(0, 50).map(function (v) { return scrub(v, depth + 1); });
    var out = {};
    Object.keys(value).forEach(function (k) { if (DENY.test(k)) return; var v = scrub(value[k], depth + 1); if (v !== undefined) out[k] = v; });
    return out;
  }
  // Keeps one event under PostHog's comfortable size: drops the biggest parts first.
  function fit(obj, max) {
    var json = JSON.stringify(obj);
    while (json && json.length > max) {
      var keys = Object.keys(obj); if (!keys.length) break;
      var big = keys.reduce(function (a, k) { return JSON.stringify(obj[k] || '').length > JSON.stringify(obj[a] || '').length ? k : a; }, keys[0]);
      delete obj[big]; json = JSON.stringify(obj);
    }
    return obj;
  }
  // Used by the opt-in recorder below to show scalar values.
  window.HovGokwikSafe = function (key, value) { return DENY.test(key) || (value !== null && typeof value === 'object') ? undefined : scrub(value, 0); };
  if (!analytics || !window.addEventListener) return;
  // GoKwik's engineering and layout logging, per-row impressions, and the pixel relays
  // (trackFbStep_*, trackSnapchatStep_*, which repeat other steps): not steps. The shopper's
  // details in them are still read.
  var NOISE = /^(screen_width_.*|new_ui_shown|user_experiments_fetch(ed|_failed)|user_variant_assigned|checkout_assets_loaded|payment_method_impression|payment_page_user_info|payment_offers_available|payment_method_list|gk_address_confirm_suppressed|trackFbStep_.*|trackSnapchatStep_.*|callUserValidate|gaEvent|gaEvt|gokwik_events|focusedIn|focusedOut|app-sso-debug|aid_event_missing|unmapped_quality_indicator|leading_indicators_exp.*|merchant_last_order_exp.*|hide_offer_experiment_loaded|failed_to_log_user_info|checkout_event:(iframe_content_loaded|merchant_unhealthy))$/;
  var QUIET_TYPES = { development: 1, screenWidth: 1 };
  // How far a checkout got, in order. sa: names come from the shopifyAnalytics relay, msg: names
  // from GoKwik's typed messages.
  var STAGES = [
    ['opened', /^(iframe_content_loaded|sa:checkoutStarted)$/],
    ['phone_screen', /^(enterMobileScreen|cart_attribute_phone_prefill|truecaller_dialog_open)$/],
    ['phone_entered', /^(sa:mobileAddedGK|userMobileEnter|otp_less_flow_triggered|masked_otp_sent|truecaller_continue_clicked)$/],
    ['otp_screen', /^(enterOtpScreen|sa:otpSent)$/],
    ['otp_entered', /^(sa:otpEntered|verifty_otp|auto_read_otp_done)$/],
    ['logged_in', /^(login_complete|sa:otpVerified|msg:user_verified_by_otp|otp_bypass_(new|repeat)_user|masked_otp_verified|skip_otp_clicked)$/],
    ['address', /^(address_step_reached|addresslistloaded|addaddress_pageload|masked_addresses_available|sa:addressStep)$/],
    ['address_entered', /^(sa:addressAdded|msg:guest_user_added_address|newaddressaddedmovetopay|addressSelectedMoveToPay)$/],
    ['payment', /^(payment_step_landed|sa:paymentStep)$/],
    ['payment_method', /^(payment_method_selected|payVia(cod|upi|Netbanking)|pay_via_(?!upi_collect_initiated).*|pp_button_clicked|wallet_selected|netbanking_bank_selected|sa:paymentMethod)$/],
    ['payment_started', /^(get_qr_code|upi_payment_initiat.*|upi_payment_status_awaited|psp_click_.*|pay_via_upi_collect_initiated_.*|msg:upiLink|card_(selected|added)_move_to_pay.*|cod_confirmation_yes|two_step_cod_confirmation|redirect_to_bank_clicked|upi_collect_payment_awaited)$/],
    ['order_placed', /^(payment_completed|netbanking_order_success|sa:orderPlaced|msg:orderSuccess)$/]
  ];
  // Typed messages that count as steps. upiLink is a pay link and goes by name only.
  var MSG_STEPS = { user_verified_by_otp: 1, guest_user_added_address: 1, upiLink: 1, couponRemoved: 1, call_geolocation_api: 1, truecaller_login: 1, cash_to_prepaid: 1, remove_cash_to_prepaid: 1 };
  var RESERVED = { provider: 1, gk_event: 1, gk_channel: 1, gk_event_type: 1, seconds_since_open: 1, furthest_step: 1, gk_data: 1 };
  var run = null;
  // clicked: when the shopper tapped checkout (set by the tap detector above); rendered: when
  // GoKwik's window reported its content loaded. load_ms is the gap between the two.
  function reset(clicked, source) { run = { opened: Date.now(), clicked: clicked == null ? null : clicked, source: source || null, rendered: null, stage: -1, last: '', prefill_type: null, prefill_source: null, user_type: null, login_type: null, method: null, coupon: null, coupon_code: null, address_changed: false, payment_failed: false, errors: 0, sent: 0, trail: [], customer: {} }; }
  function frameOk(event) {
    if (event.origin !== 'https://pdp.gokwik.co') return false;
    var frame = document.querySelector('#gokwik-iframe');
    return !!frame && event.source === frame.contentWindow;
  }
  // The shopper, from wherever GoKwik hands this page their details: the shopifyAnalytics relay
  // (phoneNumber, userAddress), the login and guest-address messages (userData), the pixel relay
  // (pixelData) and the pincode step. The latest non-empty value wins.
  var FIELDS = { phone: ['phoneNumber', 'phone', 'mobile'], first_name: ['firstname', 'firstName', 'first_name'], last_name: ['lastname', 'lastName', 'last_name'],
    email: ['email'], address: ['address'], address1: ['address1'], address2: ['address2'], city: ['city'], state: ['state', 'province'], pincode: ['pincode', 'zip'], country: ['country'] };
  function learn(source) {
    if (!source || typeof source !== 'object') return;
    if (!run) reset();
    [source, source.userAddress, source.userData, source.pixelData].forEach(function (o) {
      if (!o || typeof o !== 'object') return;
      Object.keys(FIELDS).forEach(function (field) {
        FIELDS[field].forEach(function (key) {
          var v = o[key];
          if (typeof v === 'number') v = String(v);
          if (typeof v !== 'string' || !(v = v.trim()) || v === '.' || v === 'NA') return;
          if (field === 'phone') { v = v.replace(/[\s-]/g, ''); if (!/^\+?\d{10,13}$/.test(v)) return; }
          if (field === 'email' && v.indexOf('@') < 1) return;
          // The pixel relay sends state as a two-letter code; keep the full name once known.
          if ((field === 'state' || field === 'country') && run.customer[field] && v.length <= 3 && run.customer[field].length > v.length) return;
          run.customer[field] = v.slice(0, 300);
        });
      });
    });
  }
  function who() {
    var c = run.customer, out = {};
    if (c.phone) out.customer_phone = c.phone;
    var name = [c.first_name, c.last_name].filter(Boolean).join(' ');
    if (name) out.customer_name = name;
    if (c.email) out.customer_email = c.email;
    ['address', 'address1', 'address2', 'city', 'state', 'pincode', 'country'].forEach(function (k) { if (c[k]) out['customer_' + k] = c[k]; });
    return out;
  }
  function since() { return run.clicked != null ? run.clicked : run.opened; }
  function timing() {
    var t = { rendered: run.rendered != null };
    if (run.clicked != null && run.rendered != null) t.load_ms = run.rendered - run.clicked;
    if (run.source) t.checkout_source = run.source;
    return t;
  }
  window.HovCheckoutClicked = function (source) {
    if (run && !run.closed && (run.stage >= 0 || run.clicked != null)) close('reopened');
    reset(Date.now(), source);
  };
  function close(how) {
    if (!run || run.closed) return;
    run.closed = true;
    analytics.capture('hov_checkout_closed', Object.assign({
      provider: 'gokwik', how: how, furthest_step: run.stage >= 0 ? STAGES[run.stage][0] : 'none', last_gokwik_event: run.last,
      seconds_open: Math.round((Date.now() - since()) / 1000), prefill_type: run.prefill_type, prefill_source: run.prefill_source,
      user_type: run.user_type, login_type: run.login_type, payment_method: run.method, coupon: run.coupon, coupon_code: run.coupon_code,
      address_changed: run.address_changed, payment_failed: run.payment_failed, checkout_errors: run.errors,
      // Every step GoKwik reported, as name@seconds, so the close alone tells the whole path.
      gk_steps: run.trail
    }, timing(), who()));
  }
  // body: GoKwik's fields for the step, merged into the event; data: a whole payload, kept under gk_data.
  function step(name, eventType, body, channel, data) {
    if (!name || NOISE.test(name) || QUIET_TYPES[eventType]) return;
    if (!run) reset();
    var props = { provider: 'gokwik', gk_event: name, gk_channel: channel, gk_event_type: typeof eventType === 'string' ? eventType : undefined, seconds_since_open: Math.round((Date.now() - since()) / 100) / 10 };
    if (name === 'iframe_content_loaded' && run.rendered == null) run.rendered = Date.now();
    var clean = fit(scrub(body || {}, 0) || {}, 20000);
    Object.keys(clean).forEach(function (k) { if (!RESERVED[k]) props[k] = clean[k]; });
    if (data) props.gk_data = fit(scrub(data, 0) || {}, 20000);
    for (var i = 0; i < STAGES.length; i++) if (STAGES[i][1].test(name) && i > run.stage) run.stage = i;
    props.furthest_step = run.stage >= 0 ? STAGES[run.stage][0] : 'none';
    run.last = name;
    if (run.trail.length < 120) run.trail.push(name + '@' + props.seconds_since_open);
    if (name === 'address_step_reached') { run.prefill_type = clean.prefill_type || null; run.prefill_source = clean.prefill_source || null; }
    if (name === 'login_complete') { run.user_type = clean.user_type || run.user_type; run.login_type = clean.login_type || null; }
    if (name === 'payment_method_selected') run.method = clean.method_name || null;
    if (name === 'coupon_code_applied') { run.coupon = clean.status === 200 ? 'applied' : 'failed'; run.coupon_code = typeof clean.title === 'string' ? clean.title : run.coupon_code; props.coupon_result = run.coupon; }
    if (name === 'checkout_event:coupon_code_failure') run.coupon = 'failed';
    if (/^checkout_event:/.test(name)) run.errors++;
    if (/^(change_address_clicked|editAddressSelected|addNewAddress|add_address_clicked|sa:editAddress)$/.test(name)) run.address_changed = true;
    if (/fail|retry_payment|expired/i.test(name) && /pay|upi|card|ofpl|pad|cod|netbanking|wallet/i.test(name)) run.payment_failed = true;
    Object.assign(props, timing(), who());
    // A runaway loop in GoKwik must not flood PostHog.
    if (++run.sent > 150) return;
    analytics.capture('hov_gokwik', props);
  }
  window.addEventListener('message', function (event) {
    if (!analytics.allowed() || !frameOk(event)) return;
    var m = event.data;
    // Sent whenever the shopper leaves at payment, whether or not an order exists.
    if (m === 'gokwikOrderCancel') return close('dismissed');
    if (!m || typeof m !== 'object') return;
    if (m.type === 'checkout_initiated') {
      // The checkout the shopper just tapped: keep its tap time. Anything else starts afresh.
      if (run && !run.closed && run.clicked != null && run.stage < 0) return;
      if (run && !run.closed && run.stage >= 0) close('reopened');
      reset(); return;
    }
    if (m.type === 'close') return close('closed');
    if (m.type === 'orderSuccess') { step('msg:orderSuccess', 'postMessage', null, 'message', m.response); return close('order_placed'); }
    if (m.type === 'userType' && typeof m.userType === 'string') { if (!run) reset(); run.user_type = m.userType.slice(0, 40); return; }
    // The back button in GoKwik's header: { type: 'triggerCloseEvent', data: { name: 'back_button_clicked', data: { pageNo } } }.
    if (m.type === 'triggerCloseEvent' && m.data && typeof m.data === 'object') return step(String(m.data.name || 'back_button_clicked'), m.data.eventType, m.data.data, 'back');
    if (MSG_STEPS[m.type]) {
      if (m.type === 'upiLink') return step('msg:upiLink', 'postMessage', null, 'message');
      learn(m);
      var rest = Object.assign({}, m); delete rest.type;
      return step('msg:' + m.type, 'postMessage', null, 'message', rest);
    }
    // shopifyAnalytics relay: the step, with its payload (cart, address, phone) under gk_data.
    if (m.analyticsName === 'shopifyAnalytics' && typeof m.eventName === 'string') { learn(m.data); return step('sa:' + m.eventName, 'relay', null, 'shopifyAnalytics', m.data); }
    if (m.type !== 'gk_sdk_event' || !m.data || typeof m.data !== 'object') return;
    var name = String(m.data.name || '');
    var body = m.data.data && typeof m.data.data === 'object' ? m.data.data : {};
    // GoKwik nests a body that has its own name one level down: { data: { data: { name, type, data } } }.
    // Its validation errors arrive this way as checkout_event (invalid_pincode, pincode_not_serviceable, ...).
    if (body.data && typeof body.data === 'object' && typeof body.data.name === 'string') {
      var inner = body.data;
      if (name === 'checkout_event') name = 'checkout_event:' + inner.name;
      body = Object.assign({}, inner.data && typeof inner.data === 'object' ? inner.data : {}, { type: inner.type });
    }
    learn(body);
    step(name, m.data.eventType, body, 'log');
  });
  // GoKwik's SDK tells the page when its modal closes, whichever way it was closed.
  var tries = 0, hook = setInterval(function () {
    var sdk = window.gokwikSdk, ready = !!sdk && typeof sdk.on === 'function';
    if (!ready && ++tries < 60) return;
    clearInterval(hook);
    if (ready) sdk.on('modal_closed', function () { close('modal_closed'); });
  }, 500);
  // Leaving with the checkout open, or tapped but never shown (a slow load, or GoKwik falling
  // back to Shopify's own checkout), closes the run with rendered: false.
  window.addEventListener('pagehide', function () { if (run && !run.closed && (run.stage >= 0 || run.clicked != null)) close('page_left'); });
})();

/* GoKwik checkout recorder, for working out which steps can be tracked. Off unless the page was
   opened with ?hov_gk_debug=1 (kept for the tab's session). Records every message GoKwik's
   frames send this page, and GoKwik requests this page makes, as names, field NAMES and times
   only, never values, in window.__hovGK and the console. Nothing is sent anywhere. */
(function () {
  var on = false;
  try {
    if (/[?&]hov_gk_debug=1\b/.test(window.location.search)) sessionStorage.setItem('hov_gk_debug', '1');
    if (/[?&]hov_gk_debug=0\b/.test(window.location.search)) sessionStorage.removeItem('hov_gk_debug');
    on = sessionStorage.getItem('hov_gk_debug') === '1';
  } catch (err) { on = false; }
  if (!on || !window.addEventListener) return;
  var t0 = Date.now(), log = window.__hovGK = [];
  var shape = function (value, depth) {
    if (value === null || typeof value !== 'object') return typeof value;
    if (Array.isArray(value)) return value.length ? [shape(value[0], depth + 1)] : [];
    if (depth > 2) return 'object';
    var out = {};
    Object.keys(value).slice(0, 40).forEach(function (k) { out[k] = shape(value[k], depth + 1); });
    return out;
  };
  var note = function (kind, name, detail) {
    var row = { t: ((Date.now() - t0) / 1000).toFixed(2), kind: kind, name: name, detail: detail };
    log.push(row);
    try { sessionStorage.setItem('hov_gk_log', JSON.stringify(log.slice(-400))); } catch (err) { /* full */ }
    if (window.console) console.log('[hov-gk]', row.t + 's', kind, name, detail);
  };
  window.addEventListener('message', function (event) {
    if (!/gokwik\.(co|in|io)$/.test(new URL(event.origin || 'null', window.location.href).hostname || '')) return;
    var d = event.data, name = '';
    if (typeof d === 'string') { name = 'string:' + d.slice(0, 40).replace(/[0-9]/g, '#'); d = null; }
    else if (d && d.type === 'gk_sdk_event' && d.data && typeof d.data === 'object') {
      // GoKwik's own step log: { type, data: { name, eventType, data: {...} } }. Scalar values of
      // the inner data are kept only when they are short words (prefill_type and the like).
      var inner = d.data, extra = {};
      var body = inner.data && typeof inner.data === 'object' ? inner.data : {};
      Object.keys(body).slice(0, 30).forEach(function (k) {
        var v = body[k];
        extra[k] = window.HovGokwikSafe && window.HovGokwikSafe(k, v) !== undefined ? window.HovGokwikSafe(k, v) : typeof v;
      });
      note('gk', String(inner.name || '(no name)'), { eventType: inner.eventType, data: extra, top: Object.keys(inner).length });
      return;
    }
    else if (d && typeof d === 'object') name = [d.analyticsName, d.eventName || d.event || d.type || d.action || d.name].filter(Boolean).join('/');
    note('message', name || '(unnamed)', { origin: event.origin, shape: d ? shape(d, 0) : null });
  });
  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (!/gokwik/.test(e.name)) return;
          var u = new URL(e.name);
          note('request', u.hostname + u.pathname.replace(/[0-9a-f-]{16,}/gi, ':id').replace(/\d{5,}/g, ':n'), { initiator: e.initiatorType, query_keys: Array.from(u.searchParams.keys()) });
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (err) { /* older browsers */ }
  }
  ['dataLayer'].forEach(function (key) {
    var layer = window[key] = window[key] || [];
    var push = layer.push;
    layer.push = function () {
      Array.prototype.forEach.call(arguments, function (a) { if (a && typeof a === 'object') note('dataLayer', String(a.event || a[0] || '(no event)'), { keys: Object.keys(a) }); });
      return push.apply(layer, arguments);
    };
  });
  // GoKwik's page-side code logs its steps through gokwik.hit(name, eventType, data) and its SDK
  // through gokwikSdk.emit(name); wrap both once they exist (names and field names only).
  var wrapped = setInterval(function () {
    var g = window.gokwik, sdk = window.gokwikSdk;
    if (g && typeof g.hit === 'function' && !g.__hovRec) {
      var hit = g.hit;
      g.hit = function (name, kind, data) { note('hit', String(name), { eventType: kind, keys: data && typeof data === 'object' ? Object.keys(data) : typeof data }); return hit.apply(this, arguments); };
      g.__hovRec = true;
    }
    if (sdk && typeof sdk.emit === 'function' && !sdk.__hovRec) {
      var emit = sdk.emit;
      sdk.emit = function (name) { note('sdk', String(name), { args: arguments.length - 1 }); return emit.apply(this, arguments); };
      sdk.__hovRec = true;
    }
    if (g && g.__hovRec && sdk && sdk.__hovRec) clearInterval(wrapped);
  }, 200);
  var lastSrc = '';
  setInterval(function () {
    var f = document.querySelector('#gokwik-iframe');
    var src = f ? (f.getAttribute('src') || '') : '';
    if (src !== lastSrc) {
      lastSrc = src;
      var path = '';
      try { var u = new URL(src, window.location.href); path = u.hostname + u.pathname + ' ?' + Array.from(u.searchParams.keys()).join(','); } catch (err) { path = src ? '(unparsed)' : ''; }
      note('frame', src ? 'iframe src' : 'iframe gone', { at: path });
    }
  }, 250);
  note('recorder', 'on', { page: window.location.pathname });
})();
